import { FALSE } from "constants/primitives";
import isArray from "./isArray";
import isString from "./isString";

const includes = <T>(haystack: string | T[], needle: T) => {
  if (isArray(haystack)) {
    return (haystack as T[]).includes(needle);
  }

  if (isString(haystack)) {
    return (haystack as string).includes(needle as unknown as string);
  }

  return FALSE;
};

export default includes;
